import {
  AppRegistration,
  Architecture,
  Assignment,
  BarChart,
  Build,
  CellTower,
  Collections,
  ConnectedTv,
  Dashboard,
  DirectionsCar,
  DomainAdd,
  Engineering,
  HelpCenter,
  HighlightAlt,
  LinkedCamera,
  LocalGasStation,
  People,
  PlayCircle,
  QueryStats,
  Settings,
  Support,
  VideoStable,
} from "@mui/icons-material";
import { Breadcrumbs, Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import React, { useEffect, useState } from "react";

// Mapping icon berdasarkan key
const iconMap = {
  Maintenance: <Build sx={{ mr: 0.7, fontSize: "18px" }} />,
  Users: <People sx={{ mr: 0.7, fontSize: "18px" }} />,
  Cameras: <LinkedCamera sx={{ mr: 0.7, fontSize: "18px" }} />,
  Features: <Architecture sx={{ mr: 0.7, fontSize: "18px" }} />,
  Results: <AppRegistration sx={{ mr: 0.7, fontSize: "18px" }} />,
  Settings: <Settings sx={{ mr: 0.7, fontSize: "18px" }} />,
  Dashboard: <Dashboard sx={{ mr: 0.7, fontSize: "18px" }} />,
  Main: <BarChart sx={{ mr: 0.7, fontSize: "18px" }} />,
  Analitik: <QueryStats sx={{ mr: 0.7, fontSize: "18px" }} />,
  PPE: <Engineering sx={{ mr: 0.7, fontSize: "18px" }} />,
  Vehicle: <DirectionsCar sx={{ mr: 0.7, fontSize: "18px" }} />,
  Monitoring: <ConnectedTv sx={{ mr: 0.7, fontSize: "18px" }} />,
  "Camera Online": <CellTower sx={{ mr: 0.7, fontSize: "18px" }} />,
  Task: <Assignment sx={{ mr: 0.7, fontSize: "18px" }} />,
  "Live View": <PlayCircle sx={{ mr: 0.7, fontSize: "18px" }} />,
  Recordings: <VideoStable sx={{ mr: 0.7, fontSize: "18px" }} />,
  ROI: <HighlightAlt sx={{ mr: 0.7, fontSize: "18px" }} />,
  Events: <Collections sx={{ mr: 0.7, fontSize: "18px" }} />,
  Sites: <DomainAdd sx={{ mr: 0.7, fontSize: "18px" }} />,
  Places: <LocalGasStation sx={{ mr: 0.7, fontSize: "18px" }} />,
  History: <QueryStats sx={{ mr: 0.7, fontSize: "18px" }} />,
  Help: <HelpCenter sx={{ mr: 0.7, fontSize: "18px" }} />,
  Support: <Support sx={{ mr: 0.7, fontSize: "18px" }} />,
};

const BreadcrumbsCustom = (props) => {
  const { arrPath } = props;
  const [arrFinal, setArrFinal] = useState<React.ReactNode[]>([]);

  useEffect(() => {
    const arrFinalTemp: React.ReactNode[] = [];

    if (Array.isArray(arrPath) && arrPath.length > 0) {
      arrPath.forEach((obj, idx) => {
        const isLast = idx === arrPath.length - 1;
        const icon = iconMap[obj.key] || null;
        const label = obj.value || obj.key;
        const path = obj.path || "#";

        arrFinalTemp.push(
          <MuiLink
            key={idx}
            underline="none"
            component={isLast ? "span" : RouterLink}
            to={isLast ? undefined : path}
            sx={{
              display: "flex",
              alignItems: "center",
              color: isLast ? "text.primary" : "grey",
              fontSize: "14px",
              fontWeight: isLast ? 600 : 400,
              cursor: isLast ? "default" : "pointer",
              textDecoration: "none",
            }}
          >
            {icon}
            {label}
          </MuiLink>,
        );
      });
      setArrFinal(arrFinalTemp);
    } else {
      setArrFinal([]);
    }
  }, [arrPath]);

  return (
    <div
      style={{
        marginLeft: "0px",
        borderRadius: "15px",
        boxShadow: "0px 5px 8px -5px lightblue",
        padding: "7px",
        cursor: "pointer",
      }}
    >
      <Breadcrumbs separator="/" aria-label="breadcrumb">
        {arrFinal}
      </Breadcrumbs>
    </div>
  );
};

export default BreadcrumbsCustom;
